/**
 * Power move: its glyph slammed onto the screen in a splash of ink with a seal ring of the art's
 * colour, then brushed away.
 */
import { mulberry32 } from '@nine/shared';
import { HAN, UI } from '../labels';
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'stamp',
  layer: 'top',
  order: 200,
  draw(f) {
    const st = f.effects.stamp;
    if (!st) return;
    const mg = f.mg;
    const k = st.t / st.life;
    const slam = st.t < 0.12 ? 1.9 - (st.t / 0.12) * 0.9 : 1 + (st.t - 0.12) * 0.06;
    const a = k > 0.72 ? 1 - (k - 0.72) / 0.28 : Math.min(1, st.t / 0.06);
    const R = Math.min(f.screenW, f.screenH) * 0.075;
    // Out at the left edge of the frame, clear of the fighter and the fight around them.
    const cx = Math.max(R * 1.6, f.screenW * 0.12);
    const cy = f.screenH * 0.42;
    const rnd = mulberry32(st.seed | 0);
    mg.save();
    mg.globalAlpha = a;
    mg.translate(cx, cy);
    mg.scale(slam, slam);
    // Ink splash: a ragged blot with droplets flung outward.
    mg.fillStyle = 'rgba(8,6,10,.82)';
    mg.beginPath();
    for (let i = 0; i <= 28; i++) {
      const ang = (i / 28) * Math.PI * 2;
      const r = R * (1.05 + rnd() * 0.3);
      if (i) mg.lineTo(Math.cos(ang) * r, Math.sin(ang) * r * 0.92);
      else mg.moveTo(Math.cos(ang) * r, Math.sin(ang) * r * 0.92);
    }
    mg.fill();
    for (let i = 0; i < 14; i++) {
      const ang = rnd() * Math.PI * 2;
      const d = R * (1.3 + rnd() * 0.7);
      mg.beginPath();
      mg.arc(Math.cos(ang) * d, Math.sin(ang) * d, 2 + rnd() * R * 0.07, 0, Math.PI * 2);
      mg.fill();
    }
    // A dry brush stroke sweeping out beneath, thick at the start and tapering to bristles.
    const sweep = Math.min(1, st.t / 0.18);
    const len = R * 3.4 * sweep;
    mg.fillStyle = 'rgba(8,6,10,.75)';
    mg.beginPath();
    mg.moveTo(-R * 1.1, R * 0.55);
    mg.quadraticCurveTo(-R * 0.2 + len * 0.4, R * 0.45, -R * 1.1 + len, R * 0.78);
    mg.quadraticCurveTo(-R * 0.2 + len * 0.4, R * 1.12, -R * 1.1, R * 1.05);
    mg.fill();
    for (let i = 0; i < 5; i++)
      mg.fillRect(-R * 1.1 + len * (0.7 + rnd() * 0.3), R * (0.62 + i * 0.07), R * 0.25, 1.5);
    // Seal ring.
    mg.strokeStyle = `rgb(${st.col})`;
    mg.lineWidth = Math.max(3, R * 0.06);
    mg.beginPath();
    mg.arc(0, 0, R * 0.86, 0, Math.PI * 2);
    mg.stroke();
    mg.lineWidth = 1.5;
    mg.beginPath();
    mg.arc(0, 0, R * 0.74, 0, Math.PI * 2);
    mg.stroke();
    // The glyph, white hot with a coloured glow.
    mg.textAlign = 'center';
    mg.textBaseline = 'middle';
    mg.font = `900 ${Math.round(R * 1.15)}px ${HAN}`;
    mg.shadowColor = `rgb(${st.col})`;
    mg.shadowBlur = R * 0.35;
    mg.fillStyle = '#fff6ea';
    mg.fillText(st.glyph, 0, R * 0.02);
    mg.shadowBlur = 0;
    mg.font = `600 ${Math.round(R * 0.26)}px ${UI}`;
    mg.fillStyle = `rgb(${st.col})`;
    mg.strokeStyle = 'rgba(8,6,10,.95)';
    mg.lineWidth = 4;
    mg.strokeText(st.name, 0, R * 0.78);
    mg.fillText(st.name, 0, R * 0.78);
    mg.restore();
    mg.textAlign = 'center';
    mg.textBaseline = 'alphabetic';
  },
});
